import React from 'react';
import { formatCommunityResultDisplay } from '../../utils/communityResultDisplay';
import { leaderboardRankEmoji } from '../../utils/communityLeaderboardDisplay';

function RankMark({ rank }) {
	if (rank > 3) {
		return (
			<span className="text-sm font-semibold tabular-nums text-gray-400 dark:text-gray-500">{rank}</span>
		);
	}

	return (
		<span className="text-lg leading-none" aria-hidden="true">
			{leaderboardRankEmoji(rank)}
		</span>
	);
}

function LeaderboardRow({ row, isYou }) {
	const accent =
		row.rank === 1
			? 'border-yellow-300 dark:border-yellow-700'
			: row.rank === 2
				? 'border-gray-300 dark:border-gray-600'
				: row.rank === 3
					? 'border-red-300 dark:border-red-800'
					: 'border-transparent';

	return (
		<li
			className={`flex items-center gap-4 rounded-xl border px-4 py-3 ${
				isYou
					? 'border-blue-200 bg-blue-50 dark:border-blue-800 dark:bg-blue-900 dark:bg-opacity-20'
					: `border-gray-200 bg-white dark:border-dark-border dark:bg-dark-card ${accent !== 'border-transparent' ? `border-l-4 ${accent}` : ''}`
			}`}
		>
			<div className="flex h-8 w-8 shrink-0 items-center justify-center">
				<RankMark rank={row.rank} />
			</div>
			<div className="min-w-0 flex-1">
				<div className="flex flex-wrap items-center gap-2">
					<p className="truncate text-base font-medium text-gray-900 dark:text-dark-text">
						{row.profile_name}
					</p>
					{isYou && (
						<span className="rounded-full bg-blue-600 px-2 py-0.5 text-xs font-medium text-white dark:bg-blue-500">
							You
						</span>
					)}
				</div>
				{row.result_entered_at && (
					<p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">
						{new Date(row.result_entered_at).toLocaleDateString(undefined, {
							month: 'short',
							day: 'numeric'
						})}
					</p>
				)}
			</div>
			<p className="shrink-0 text-2xl font-semibold tracking-tight tabular-nums text-gray-900 dark:text-dark-text">
				{formatCommunityResultDisplay(row.result_display)}
			</p>
		</li>
	);
}

export default function CommunityLeaderboard({
	rows = [],
	viewerParticipationId = null,
	emptyMessage = 'No results yet.'
}) {
	if (!rows.length) {
		return (
			<div className="rounded-xl border border-dashed border-gray-300 dark:border-dark-border bg-white dark:bg-dark-card px-6 py-12 text-center">
				<p className="text-sm text-gray-600 dark:text-gray-400">{emptyMessage}</p>
			</div>
		);
	}

	return (
		<ul className="space-y-2">
			{rows.map((row) => (
				<LeaderboardRow
					key={row.participation_id}
					row={row}
					isYou={viewerParticipationId === row.participation_id}
				/>
			))}
		</ul>
	);
}
